//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.h5`
    background-color: var(--light-gray-4);
    color: var(--light-1);
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    font-size: 12px;
    border-radius: 4px;
    width: 100%;
    margin-top: 5px;
    margin-bottom: 8px;
`;